/* eslint-disable react/destructuring-assignment,react/require-default-props,react/no-unused-prop-types,react/default-props-match-prop-types */

import _once from 'lodash/once';
import $ from 'jquery';

import React from 'react';
import PropTypes from 'prop-types';

/**
 * This component allows you to dynamically request scripts when needed,
 * rather than requiring everything in the <head> tag.
 *
 * More for libraries we should not be including into webpack where async
 * loading isn't an option.
 *
 * It also checks if the library has already been included to avoid multiple
 * requests.
 */
export class LoadJsScript extends React.Component {
  constructor(props) {
    super(props);

    this.oneTimeCallback = _once(() => {
      props.onLoad();
    });
  }

  componentWillMount() {
    // Strangely enough, sometimes componentWillMount() is called twice
    // @see https://github.com/reactjs/react-redux/issues/210
    // Putting oneTimeCallback into the constructor avoids this issue.

    // Check if we already know about this one
    if ($(`head script[src="${this.props.src}"]`, window.document).length > 0) {
      this.oneTimeCallback();
      return;
    }

    // @see https://stackoverflow.com/a/950146/253704
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = this.props.src;

    // Then bind the event to the callback function.
    // There are several events for cross browser compatibility.
    script.onreadystatechange = this.oneTimeCallback;
    script.onload = this.oneTimeCallback;

    // Fire the loading
    head.appendChild(script);
  }

  render() {
    return null;
  }
}

LoadJsScript.propTypes = {
  src: PropTypes.string.isRequired,
  onLoad: PropTypes.func.isRequired,
  async: PropTypes.bool.isRequired,
};

LoadJsScript.defaultProps = {
  onLoad: () => {},
  async: true,
};
